// extracted by mini-css-extract-plugin
module.exports = {"hiring":"SpringCog_hiring__1Vkwp","compName":"SpringCog_compName__2KyIl","hiring2":"SpringCog_hiring2__3JMeU","compName2":"SpringCog_compName2__RZWb9"};